module.exports = __webpack_public_path__ + "img/second_setup.6aba8a58.png";